/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_UrlInputs */



/**
* | output |
* | --- |
* | "Address" |
*
* @param {Community_Link_UrlInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_url = /** @type {((inputs?: Community_Link_UrlInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_UrlInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adresse")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dirección")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Endereço")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indirizzo")
	return /** @type {LocalizedString} */ ("Address")
});